import Section from '@pelckmans/elementis/components/section';
import { Medialink } from '../../../../../api/medialink';
import AssignmentMedialinksSection from './AssignmentMedialinksSection';
import MedialinksSection from './MedialinksSection';
import SharedMedialinksSection from './SharedMedialinksSection';
import { useTranslation } from 'react-i18next';
import LoadingState from '../../../../../shared-components/LoadingState';

function splitMedialinks(medialinks: Medialink[]) {
  return medialinks.reduce(
    (
      acc: { assignmentMedialinks: Medialink[]; teacherMedialinks: Medialink[]; studentMedialinks: Medialink[] },
      medialink,
    ) => {
      if (
        medialink.assignments.length > 0 &&
        (medialink.score?.status !== 'finished' || medialink.assignments.some(x => x.repeatable))
      ) {
        acc.assignmentMedialinks.push(medialink);
      }

      if (medialink.group === 'teacher' && !Boolean(medialink.assignments.length)) {
        acc.teacherMedialinks.push(medialink);
      }

      if (medialink.group === 'student') {
        acc.studentMedialinks.push(medialink);
      }
      return acc;
    },
    { assignmentMedialinks: [], teacherMedialinks: [], studentMedialinks: [] },
  );
}

interface Props {
  medialinks?: Medialink[];
  getMedialinksForExerciseCategory: () => Promise<void>;
}

function MaterialSection({ medialinks, getMedialinksForExerciseCategory }: Props) {
  const { t } = useTranslation();

  if (medialinks === undefined) {
    return (
      <Section title={t('PAGES.VEM.MATERIAL_SECTION.TITLE')}>
        <LoadingState variant="list" aria-label={t(`PAGES.VEM.MATERIAL_SECTION.LOADING.A11Y_LABEL`)} />
      </Section>
    );
  }

  const { assignmentMedialinks, teacherMedialinks, studentMedialinks } = splitMedialinks(medialinks);

  return (
    <div className="material-sections">
      <AssignmentMedialinksSection
        medialinks={assignmentMedialinks}
        getMedialinksForExerciseCategory={getMedialinksForExerciseCategory}
      />
      <SharedMedialinksSection
        medialinks={teacherMedialinks}
        getMedialinksForExerciseCategory={getMedialinksForExerciseCategory}
      />
      <MedialinksSection
        medialinks={studentMedialinks}
        getMedialinksForExerciseCategory={getMedialinksForExerciseCategory}
      />
    </div>
  );
}

export default MaterialSection;
